import React, { useState, useEffect, useContext, useCallback } from 'react';
import Header from '../../components/Header';
import MobileNavbar from '../../components/MobileNavbar';
import Sidebar from '../../components/Sidebar';
import './index.css';
import { Button } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CarDropdown from '../../components/CarDropdown';
import CouponDropdown from '../../components/CouponDropdown';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import {
  get_car_booking,
  update_full_booking,
  get_discount_price,
  get_car,
} from '../../API/car_booking';
import { get_user } from '../../API/user';
import { get_all_delivery_charges } from '../../API/setting';
import { get_coupons } from '../../API/coupon';
import { format, add, isValid } from 'date-fns';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBooking,
  bookingSelector,
  clearState,
} from '../../reducers/bookingSlice';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Carousel from 'react-material-ui-carousel';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import TimeDropdown from '../../components/TimeDropdown';
import { get_all_airlines } from '../../API/setting';
import { get_system_configurations } from '../../API/system_configurations';
import Box from '@mui/material/Box';
import { useCarsDropdown } from '../../hooks/useCarsDropdown'
import dayjs from 'dayjs';
import moment from 'moment';

export default function EditTrip() {
  // const [selectedFile, setSelectedFile] = useState();
  const { authAxios, user } = useContext(AuthContext);
  const [coupons, setCoupons] = useState(null);
  const [airports, setAirports] = useState(null);
  const [airlines, setAirlines] = useState(null);

  // const [initCoupon, setInitCoupon] = useState(null);
  const { booking } = useSelector(bookingSelector);
  const navigate = useNavigate();
  const {
    fromDate,
    fromTime,
    untilDate,
    untilTime,
    pickupLocation,
    dropoffLocation,
    destination_location,
    pickup_location,
    dropoff_location,
    car: selectedCar,
    coupon_code: selectedCoupon,
    deliveryCharge,
    customer,
    customerName,
  } = booking;

  const { customer_id, id: trip_id } = useParams();
  const [systemConfigurations, setSystemConfigurations] = useState(null);
  const [loading, setLoading] = useState(false);
  const [carDetail, setCarDetail] = useState(null);
  const [carDetailForEdit, setCarDetailForEdit] = useState(null);

  useEffect(() => {
    get_car(authAxios, selectedCar,)
      .then((res) => {
        if (res.status === 200) {
          setCarDetailForEdit(res.data)
          console.log(res.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });

  }, [authAxios, selectedCar]);

  const dispatch = useDispatch();

  // const format_date_time = (date, time) => {
  //   return date && format(date, 'yyyy-MM-dd') + 'T' + time;
  // };

  useEffect(() => {
    const bookingPatch = {};
    airports?.forEach(airport => {
      if (airport.airport === pickup_location) {
        bookingPatch.pickupLocation = airport;
      }
      if (airport.airport === destination_location) {
        bookingPatch.dropoffLocation = airport;
      }
    })
    if (Object.keys(bookingPatch)?.length > 0) {
      dispatch(
        setBooking({
          ...booking,
          ...bookingPatch
        })
      )
    }
  }, [pickup_location, destination_location, airports])

  const today = format(new Date(), 'yyyy-MM-dd');

  const format_date_time = (date, time) => {
    return date && format(date, 'yyyy-MM-dd') + 'T' + time;
  };

  const fromDateTime = isValid(fromDate)
    ? format_date_time(fromDate, fromTime)
    : null;
  const untilDateTime = isValid(untilDate)
    ? format_date_time(untilDate, untilTime)
    : null;

  const [carArray] = useCarsDropdown(fromDateTime, untilDateTime, customer_id, null, null, selectedCar, booking.id);

  const getCustomer = async () => {
    let res = await get_user(authAxios, customer_id);
    if (res.status === 200) {
      dispatch(
        setBooking({
          ...booking,
          ...res.data,
          id: booking.id,
          customerName: res.data.name,
          customer: res.data,
          insurance_expiry_date: res.data.insurance_expiry_date,
          email: res.data.user?.email,
          username: res.data.user?.username,
          address: res.data.address || '_',
          postal_code: res.data.postal_code || '_',
          phone: res.data.phone || '_',
        })
      );
    } else {
      toast.error(Object.values(res.response.data)[0]);
      return {};
    }
  };

  const getCoupons = async () => {
    let res = await get_coupons(authAxios);
    if (res.status === 200) {
      setCoupons(res.data);
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  const getAllDeliveryCharges = async () => {
    let res = await get_all_delivery_charges(authAxios);
    if (res.status === 200) {
      setAirports(res.data);
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  const getAirlines = async () => {
    let res = await get_all_airlines(authAxios);
    if (res.status === 200) {
      setAirlines(res.data);
    } else {
      toast.error(Object.values(res.response.data)[0]);
    }
  };

  const getAirportDetail = (airportName) => {
    let airportDetail = (airports || []).find(
      ({ airport }) => airport === airportName
    );
    return airportDetail;
  };

  
  const get_booking = async () => {
    let res = await get_car_booking(authAxios, trip_id);
    if (res.status === 200) {
      dispatch(
        setBooking({
          ...res.data,
          customerName: booking.customerName,
          customer: booking.customer,
          insurance_expiry_date: booking.insurance_expiry_date,
          email: booking.email,
          username: booking.username,
          address: booking.address,
          postal_code: booking.postal_code,
          phone: booking.phone,
          car: res.data.car.id,
          fromDate: format(new Date(res.data.start_date), 'yyyy-MM-dd'),
          fromTime: res.data.start_date.split('T')[1],
          untilDate: format(new Date(res.data.end_date), 'yyyy-MM-dd'),
          untilTime: res.data.end_date.split('T')[1],
          deliveryCharge: res.data.delivery_charge,
          pickupLocation: getAirportDetail(res.data.pickup_location),
          dropoffLocation: getAirportDetail(res.data.destination_location),
          initPrice: Number(res.data.price),
        })
      );
    } else {
      Object.keys(res.response.data).forEach((key) => {
        toast.error('key: ' + res.response.data[key]);
      });
    }
  };

  const getCarPrice = () => {
    return Number(carDetail?.daily_price);
  };

  useEffect(() => {
    const load = async () => {
      await getCoupons();
      await getAllDeliveryCharges();
      await getAirlines();
    };
    load();
  }, []);

  useEffect(() => {
    if (customer_id) {
      getCustomer();
    }
  }, [customer_id]);

  useEffect(() => {
    if (customerName) {
      get_booking();
    }
  }, [customerName]);

  useEffect(() => {
    if (selectedCar) {
      setCarDetail(carArray?.data?.find(item => item.id === selectedCar))
    }
  }, [carArray, booking.customer])

  useEffect(() => {
      if (pickupLocation && dropoffLocation && booking.car) {
        let extraDays = 0;
        if (Number(untilTime.slice(0,2)) < Number(fromTime.slice(0,2))) {
          extraDays = 1;
        }

        dispatch(
          setBooking({
            ...booking,
            pickup_location: pickupLocation?.airport ?? booking.pickup_location,
            destination_location: dropoffLocation?.airport ?? destination_location,
            deliveryCharge: days < 7 ? Number((
              Number(pickupLocation?.delivery_charge || 0) + Number(dropoffLocation?.delivery_charge || 0)
            ).toFixed(2)): 0,
          })
        );
      }
  }, [pickupLocation, dropoffLocation, booking.car, untilTime, fromTime, untilDate, fromDate]);

  useEffect(() => {
    get_system_configurations(authAxios).then((res) => {
      setSystemConfigurations(res.data[0] || {});
    });
  }, []);

  useEffect(() => {
    if (fromDate > untilDate) {
      const newDate = add(fromDate, { days: 3 });
      dispatch(setBooking({ ...booking, untilDate: newDate }));
    }
  }, [fromDate]);

  const getIntervalDays = (fromDate, fromTime, untilDate, untilTime) => {
    // return Math.ceil(
    //   (new Date(format_date_time(untilDate, untilTime)).getTime() -
    //     new Date(format_date_time(fromDate, fromTime)).getTime()) /
    //     (1000 * 60 * 60 * 24)
    // );
    return Math.ceil(
      (new Date(untilDate + 'T' + untilTime).getTime() -
        new Date(fromDate + 'T' + fromTime).getTime()) /
        (1000 * 60 * 60 * 24)
    );
  };

  const days = getIntervalDays(fromDate, fromTime, untilDate, untilTime);

  const handleSave = async (e) => {
    e.preventDefault();

    if (
      !booking?.pickup_location || !booking?.destination_location
    ) {
      return confirmAlert({
        overlayClassName: 'errorModal',
        customUI: ({ onClose }) => {
          return (
            <div
              className='confModal'
              style={{
                height: '190px',
                marginTop: '50%',
                position: 'relative',
              }}
            >
              <div
                className='close_icon'
                style={{ top: '.75rem', right: '.25rem' }}
                onClick={() => onClose()}
              >
                <svg
                  width='25'
                  height='25'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
              <p style={{ color: 'red', paddingTop: '30px' }}>
                {
                  'Please select your pick-up and drop-off location.'
                }
              </p>
              <div className='btns'>
                <button
                  onClick={() => {
                    onClose();
                  }}
                  className='secondary'
                  style={{ width: '120px' }}
                >
                  Okay
                </button>
              </div>
            </div>
          );
        },
      });
    }

    if (getCarPrice() * days <= 0) {
      validateModal('Invalid Price', 'error');
      return;
    }

    if (!customer_id) {
      validateModal('Customer Required.', 'error');
      return;
    }

    await paymentModal();
  };

  const validateModal = (message, status) => {
    return confirmAlert({
      overlayClassName: 'errorModal',
      customUI: ({ onClose }) => {
        return (
          <div
            className='confModal'
            style={{
              height: String(120 + message.length / 2) + 'px',
              marginTop: '50%',
            }}
          >
            <h4>Are You Sure?</h4>
            <p style={{ color: 'red' }}>{message}</p>
            <div className='btns'>
              <button onClick={() => onClose()} className='secondary'>
                Cancel
              </button>
              {status != 'error' && (
                <button className='primary' onClick={paymentModal}>
                  Bypass
                </button>
              )}
            </div>
          </div>
        );
      },
    });
  };

  const paymentModal = async () => {
    const { totalAmt, discount } = await getAmounts();

    let diff_price = localStorage.getItem('finalPrice') - Number(booking.initPrice);
    // if (diff_price === 0) {
    //
    //   handleConfirm();
    //   return;
    // }

    return confirmAlert({
      overlayClassName: 'errorModal align-center',
      customUI: ({ onClose }) => {
        return (
          <div
            className='confModal'
            style={{
              height: 'auto',
              width: 'auto',
              padding: '2rem',
              maxWidth: '600px',
              position: 'relative',
            }}
          >
            <div
              className='close_icon'
              style={{ top: '.75rem', right: '0rem' }}
              onClick={() => onClose()}
            >
              <svg
                width='25'
                height='25'
                viewBox='0 0 110 110'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
            <h6>
              {diff_price > 0 ? (
                'Would you like to charge for the updated booking amount?'
              ) : (
                <div style={{ textAlign: 'left' }}>
                  <h6>
                    The changes have decreased the booking amount as provided.
                    if you would like to refund this amount to the client please
                    initiate a manual refund through the payment processor.
                  </h6>
                </div>
              )}
            </h6>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(15rem, 1fr))',
                textAlign: 'left',
                marginTop: '1rem',
              }}
            >
              <p>
                Previous amount :{' '}
                <span>$ {Number(booking.initPrice).toFixed(2)}</span>
              </p>
              <p>
                {' '}
                Current amount : <span>$ {localStorage.getItem('finalPrice')}</span>
              </p>
              {diff_price > 0 ? (
                <p>Additional Amount: $ {(diff_price || 0).toFixed(2)}</p>
              ) : (
                <p>
                  Difference Amount: ${' '}
                  {(diff_price || 0).toFixed(2).substring(1)}
                </p>
              )}
            </div>
            {diff_price > 0 ? (
              <div className='btns'>
                <button
                  onClick={() => {
                    onClose();
                    handleConfirmByPass('notCharge')
                  }}
                  className='secondary'
                >
                  Bypass
                </button>
                <button
                  className='primary'
                  onClick={() => {
                    onClose();
                    // paymentTypeModal(diff_price);
                    // proceedPaymentModal('charge');
                    handleMoveToPaymentDetails('charge');
                  }}
                >
                  Proceed
                </button>
              </div>
            ) : (
              <div className='btns'>
                <button
                  className='primary'
                  onClick={() => {
                    onClose();
                    // This should initiate manual refund to the client.
                    handleConfirmByPass('notCharge', true);
                  }}
                >
                  Proceed
                </button>
              </div>
            )}
          </div>
        );
      },
    });
  };

  const proceedPaymentModal = async (charged) => {
    return confirmAlert({
      overlayClassName: 'errorModal align-center',
      customUI: ({ onClose }) => {
        return (
          <div
            className='confModal'
            style={{
              height: 'auto',
              width: 'auto',
              padding: '2rem',
              maxWidth: '600px',
              position: 'relative',
            }}
          >
            <div
              className='close_icon'
              style={{ top: '.25rem', right: '0rem' }}
              onClick={() => onClose()}
            >
              <svg
                width='25'
                height='25'
                viewBox='0 0 110 110'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
            <div style={{ fontSize: '1.2rem' }}>
              How would you like to proceed?
            </div>
            <div className='btns' style={{ marginTop: '1rem' }}>
              <button
                onClick={() => {
                  onClose();
                  handleConfirm(charged);
                }}
                className='secondary'
                style={{ width: 'auto', fontSize: '13px' }}
              >
                Send a payment link to client
              </button>
              <button
                className='secondary'
                onClick={() => {
                  onClose();
                  handleMoveToPaymentDetails(charged);
                }}
                style={{ width: 'auto', fontSize: '13px' }}
              >
                Move To Payment Page
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const paymentTypeModal = async (diff_price) => {
    if (diff_price > 0) {
      return confirmAlert({
        overlayClassName: 'errorModal',
        customUI: ({ onClose }) => {
          return (
            <div
              className='confModal'
              style={{ height: '70px', marginTop: '50%', width: '500px' }}
            >
              <div className='btns'>
                <button
                  onClick={() => {
                    onClose();
                    proceedPaymentModal();
                  }}
                  className='secondary'
                  style={{ width: '150px' }}
                >
                  Don't Charge a bill
                </button>
                <button
                  className='secondary'
                  onClick={() => {
                    onClose();
                    proceedPaymentModal('charge');
                  }}
                  style={{ width: '150px' }}
                >
                  Charge a bill to a Client
                </button>
              </div>
            </div>
          );
        },
      });
    } else if (diff_price < 0) {
      return confirmAlert({
        overlayClassName: 'errorModal',
        customUI: ({ onClose }) => {
          return (
            <div
              className='confModal'
              style={{
                height: '170px',
                marginTop: '50%',
                width: '500px',
                position: 'relative',
              }}
            >
              <div
                className='close_icon'
                style={{ top: '.75rem', right: '.25rem' }}
                onClick={() => onClose()}
              >
                <svg
                  width='25'
                  height='25'
                  viewBox='0 0 110 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                    stroke='#FF2552'
                    strokeWidth='11.625'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
              <p>
                Changing to this vehicle reduces the price by $
                {Math.abs(diff_price).toFixed(2)}, if you would like to refund
                this amount to the client please initiate a manual refund
                through the payment processor.
              </p>
              <div className='btns'>
                <button
                  onClick={() => {
                    onClose();
                    proceedPaymentModal();
                  }}
                  className='secondary'
                  style={{ width: '150px' }}
                >
                  Proceed
                </button>
                <button
                  className='secondary'
                  onClick={() => {
                    onClose();
                  }}
                  style={{ width: '150px' }}
                >
                  Cancel
                </button>
              </div>
            </div>
          );
        },
      });
    } else proceedPaymentModal();
  };

  const handleMoveToPaymentDetails = async (charged) => {
    const { coupon_amount, totalAmt} = await getAmounts();
    const diff_price = localStorage.getItem('finalPrice') - Number(booking.initPrice)

    dispatch(
      setBooking({
        ...booking,
        customer: customer_id,
        start_date: fromDate + ' ' + fromTime,
        end_date: untilDate + ' ' + untilTime,
        daily_price: getCarPrice() ?? 0,
        img: carDetail?.car_images[0]?.image,
        carName: carDetail?.title,
        price: getCarPrice() * days,
        previous_amount: booking.initPrice,
        days: days,
        coupon_amount: coupon_amount,
        coupon_code: booking.coupon_code,
        payment_type: 'manual',
        chargeBill: charged || 'notCharge',
        isYoung: isYoung,
        diff_price
        // coupon_code: booking.coupon_code == initCoupon? undefined: booking.coupon_code
      })
    );

    navigate('/payment');
  };

  const getAmounts = async () => {
    const coupon = (coupons || []).find(
      (coupon) => coupon.code == selectedCoupon
    );
    let res = await get_discount_price(authAxios, {
      car_id: selectedCar,
      start_date: fromDate + ' ' + fromTime,
      end_date: untilDate + ' ' + untilTime,
    });
    let coupon_amount;
    if (coupon)
    coupon_amount =
      coupon?.amount_type != 'A'
        ? coupon?.amount === 100 ? Math.ceil((days * res.data.daily_price * Math.abs(coupon?.amount || 0)) / 100) : (days * res.data.daily_price * Math.abs(coupon?.amount || 0)) / 100
        : Math.abs(coupon?.amount || 0);
    else coupon_amount = 0;

    // (coupon?.amount_type != 'A'
    //   ? coupon?.amount === 100 ? Math.ceil((days * carDetail?.daily_price * Math.abs(coupon?.amount)) / 100) : (days * carDetail?.daily_price * Math.abs(coupon?.amount)) / 100
    //   : Math.abs(coupon?.amount)) || 0;

    // let res = await get_discount_price(authAxios, {
    //   car_id: selectedCar,
    //   start_date: fromDate + ' ' + fromTime,
    //   end_date: untilDate + ' ' + untilTime,
    // });

    let totalAmt = 0;
    let discount = 0;

    if (res.status === 200) {
      totalAmt = Number(res.data.total_price) - (coupon_amount || 0);
      discount = Number(res.data.discount) + (coupon_amount || 0);
    }

    const taxAmount =
      ((systemConfigurations?.tax * 100).toFixed(2) / 100) * totalAmt;

    // totalAmt +=
    //   ((Number(booking.deliveryCharge || 0) + taxAmount) * 100).toFixed(0) /
    //   100;

    // totalAmt =
    //   totalAmt *
    //   (1 +
    //     (isYoung
    //       ? Number(systemConfigurations?.young_renter_fee || 0) / 100
    //       : 0));
    totalAmt=localStorage.getItem('finalPrice');
    return { totalAmt, discount, coupon_amount };
  };

  const handleConfirmByPass = async (charged, byPassed=false) => {
    const { totalAmt, discount, coupon_amount } = await getAmounts();
    // const diff_price = Number(totalAmt) - Number(booking.initPrice);
   
    const payload = {
      ...booking,
      customer: customer_id,
      start_date: fromDate + ' ' + fromTime,
      end_date: untilDate + ' ' + untilTime,
      daily_price: totalAmt/days,
      img: carDetail?.car_images[0]?.image,
      carName: carDetail?.title,
      price: totalAmt/days,
      days: days,
      diff_price: 0,
      after_price: Number(totalAmt),
      discount_price: discount,
      pickup_location: pickupLocation?.airport || booking.pickup_location,
      destination_location:
        dropoffLocation?.airport || booking.destination_location,
      coupon_amount: coupon_amount,
      method: 'auto',
      chargeBill: charged || 'notCharge',
      editor: user.first_name + ' ' + user.last_name,
    };
    console.log("payload", payload);

    
    try {
      let res = await update_full_booking(authAxios, payload);
      if (res.status === 200) {
        setLoading(false);
        dispatch(clearState());
        navigate('/trips');
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log("err", err)
    }
  };
  const handleConfirm = async (charged, byPassed = false) => {
    const { totalAmt, discount, coupon_amount } = await getAmounts();
    const diff_price = Number(totalAmt) - Number(booking.initPrice);

    setLoading(true);

    const payload = {
      ...booking,
      customer: customer_id,
      start_date: fromDate + ' ' + fromTime,
      end_date: untilDate + ' ' + untilTime,
      daily_price: totalAmt/days,
      img: carDetail?.car_images[0]?.image,
      carName: carDetail?.title,
      price: totalAmt/days,
      days: days,
      diff_price: diff_price,
      after_price: Number(totalAmt),
      discount_price: discount,
      pickup_location: pickupLocation?.airport || booking.pickup_location,
      destination_location:
        dropoffLocation?.airport || booking.destination_location,
      coupon_amount: coupon_amount,
      method: 'auto',
      chargeBill: charged || 'notCharge',
      editor: user.first_name + ' ' + user.last_name,
    };

    console.log("payload", payload);

    
    try {
      let res = await update_full_booking(authAxios, payload);
      if (res.status === 200) {
        setLoading(false);
        dispatch(clearState());
        navigate('/trips');
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log("err", err)
    }
  };


  const CustomerModal = (customer) => {
    return confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='editModal overviewBooknigModal tripDetailModal'>
            <div
              className='close_icon'
              style={{ top: '1.5rem', right: '1.5rem' }}
              onClick={() => onClose()}
            >
              <svg
                width='25'
                height='25'
                viewBox='0 0 110 110'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M37.5625 37.5625L72.4375 72.4375M72.4375 37.5625L37.5625 72.4375L72.4375 37.5625Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M55 103.438C81.7513 103.438 103.438 81.7513 103.438 55C103.438 28.2487 81.7513 6.5625 55 6.5625C28.2487 6.5625 6.5625 28.2487 6.5625 55C6.5625 81.7513 28.2487 103.438 55 103.438Z'
                  stroke='#FF2552'
                  strokeWidth='11.625'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
            {customer.license_image && (
              <Carousel className='trip_modal_carousal'>
                <img
                  key={customer.id}
                  src={customer.license_image}
                  alt='img'
                  width={'100%'}
                />
              </Carousel>
            )}
            <div className='body_header'>
              {/* <div> Trip Management </div> */}
            </div>
            <div className='tripDetail'>
              <div className='tripDetail_col'>
                <div>
                  Customer : <span>{customer.name}</span>
                </div>
                <div>
                  Email: <span>{customer.user.email}</span>
                </div>
                <div>
                  Insurance Policy No: <span>{customer.insurance_policy}</span>
                </div>
                {!customer.license_image && (
                  <div>
                    License: <span>Not Given</span>
                  </div>
                )}
              </div>
              <div className='tripDetail_col'>
                <div>
                  Phone No: <span>{customer.phone}</span>
                </div>
                <div>
                  Address: <span>{customer.address}</span>
                </div>
                <div>
                  Insurance Expiry Date:{' '}
                  <span>{customer.insurance_expiry_date}</span>
                </div>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  const isYoung = booking.age
    ? booking.age < 25
    : new Date(fromDate + 'T' + fromTime).getTime() -
        new Date(customer?.birth_date).getTime() <
      31557600000 * 25;

  return (
    <div className='dashboard page'>
      <Sidebar page='edit_booking' />
      <div className='hero_content'>
        <MobileNavbar />
        <Header />
        <div className='pagewrapper'>
          <div className='addManualCar'>
            <h5>Edit Booking</h5>
            <form
              action='#'
              onSubmit={(e) => handleSave(e)}
              className='card_details'
            >
              {selectedCar && (
                <>
                  <div className='info_wrapper'>
                    <div className='radio_wrapper'>
                      <div className='radio' style={{ position: 'relative' }}>
                        <input
                          hidden
                          type='radio'
                          name='person_type'
                          onChange={(e) => e.target.value}
                          id='previous_customer'
                        />
                        <label
                          htmlFor='previous_customer'
                          className='radio_label'
                        >
                          <Button
                            required
                            className='user_upload_btn radio_btn'
                            variant='contained'
                            component={Link}
                            to={'/all_users/edit_booking/' + trip_id}
                          >
                            <svg viewBox='0 0 76 76' fill='none'>
                              <circle cx='38' cy='38' r='38' fill='#1C2038' />
                              <path
                                d='M38.5004 20.625C39.2463 20.625 39.9616 20.9213 40.4891 21.4488C41.0165 21.9762 41.3129 22.6916 41.3129 23.4375C41.3129 24.1834 41.0165 24.8988 40.4891 25.4262C39.9616 25.9537 39.2463 26.25 38.5004 26.25C37.7544 26.25 37.0391 25.9537 36.5116 25.4262C35.9842 24.8988 35.6879 24.1834 35.6879 23.4375C35.6879 22.6916 35.9842 21.9762 36.5116 21.4488C37.0391 20.9213 37.7544 20.625 38.5004 20.625ZM38.5004 17.8125C37.0085 17.8125 35.5778 18.4051 34.5229 19.46C33.468 20.5149 32.8754 21.9457 32.8754 23.4375C32.8754 24.9293 33.468 26.3601 34.5229 27.415C35.5778 28.4699 37.0085 29.0625 38.5004 29.0625C39.9922 29.0625 41.4229 28.4699 42.4778 27.415C43.5327 26.3601 44.1254 24.9293 44.1254 23.4375C44.1254 21.9457 43.5327 20.5149 42.4778 19.46C41.4229 18.4051 39.9922 17.8125 38.5004 17.8125ZM41.9597 30.4406H35.041C33.7207 30.4406 32.4545 30.9651 31.5209 31.8987C30.5873 32.8323 30.0629 34.0985 30.0629 35.4188V42.8437C30.0321 43.6253 30.3097 44.3876 30.8359 44.9663C31.362 45.545 32.0944 45.8938 32.8754 45.9375V52.4906C32.8754 53.3857 33.2309 54.2442 33.8639 54.8771C34.4968 55.51 35.3552 55.8656 36.2504 55.8656H40.7504C41.2032 55.8659 41.6514 55.775 42.0684 55.5984C42.4854 55.4218 42.8626 55.1631 43.1775 54.8377C43.4924 54.5123 43.7386 54.1268 43.9015 53.7043C44.0643 53.2817 44.1404 52.8307 44.1254 52.3781V45.9375C44.9063 45.8938 45.6387 45.545 46.1648 44.9663C46.691 44.3876 46.9686 43.6253 46.9379 42.8437V35.4188C46.9379 34.0985 46.4134 32.8323 45.4798 31.8987C44.5462 30.9651 43.28 30.4406 41.9597 30.4406ZM32.8754 43.125V35.4188C32.8716 35.1333 32.925 34.85 33.0325 34.5855C33.14 34.3211 33.2994 34.0809 33.5012 33.879C33.7031 33.6771 33.9433 33.5178 34.2078 33.4103C34.4722 33.3028 34.7555 33.2493 35.041 33.2531H41.9597C42.2452 33.2493 42.5285 33.3028 42.7929 33.4103C43.0574 33.5178 43.2976 33.6771 43.4995 33.879C43.7013 34.0809 43.8607 34.3211 43.9682 34.5855C44.0757 34.85 44.1291 35.1333 44.1254 35.4188V43.125H41.3129V52.4344C41.3129 52.5836 41.2536 52.7266 41.1481 52.8321C41.0426 52.9376 40.8995 52.9969 40.7504 52.9969H36.2504C36.1012 52.9969 35.9581 52.9376 35.8526 52.8321C35.7471 52.7266 35.6879 52.5836 35.6879 52.4344V43.125H32.8754Z'
                                fill='#4FC8E9'
                              />
                            </svg>
                            {customerName
                              ? customerName
                              : 'Select Existing Client'}
                          </Button>
                        </label>
                        {customer && (
                          <div
                            onClick={() => CustomerModal(customer)}
                            style={{
                              position: 'absolute',
                              bottom: '10px',
                              right: '20px',
                              fontSize: '12px',
                              background: '#4fc8e9',
                              borderRadius: '5px',
                              padding: '4px 8px',
                              cursor: 'pointer',
                            }}
                          >
                            View
                          </div>
                        )}
                      </div>
                      <div className='radio'>
                        <input
                          hidden
                          type='radio'
                          name='person_type'
                          onChange={(e) => e.target.value}
                          id='add_new_person'
                        />
                        <label htmlFor='add_new_person' className='radio_label'>
                          <Button
                            required
                            className='user_upload_btn radio_btn'
                            variant='contained'
                            component={Link}
                            to={`/add_person/${customer_id}/${trip_id}`}
                          >
                            <svg viewBox='0 0 76 76' fill='none'>
                              <circle cx='38' cy='38' r='38' fill='#1C2038' />
                              <path
                                fillRule='evenodd'
                                clipRule='evenodd'
                                d='M46.5023 43.3671H43.6898V48.9921H38.0648V51.8046H43.6898V57.4296H46.5023V51.8046H52.1273V48.9921H46.5023V43.3671ZM34.0036 21.3424C33.6964 21.137 33.3519 20.9942 32.9896 20.922C32.6273 20.8498 32.2543 20.8497 31.8919 20.9216C31.5295 20.9936 31.1849 21.1362 30.8776 21.3413C30.5704 21.5465 30.3066 21.8101 30.1012 22.1172C29.8959 22.4243 29.753 22.7689 29.6808 23.1312C29.6086 23.4935 29.6085 23.8665 29.6804 24.2289C29.7524 24.5912 29.895 24.9359 30.1001 25.2431C30.3053 25.5504 30.5689 25.8142 30.8761 26.0196C31.4963 26.4343 32.2559 26.5857 32.9877 26.4404C33.7195 26.295 34.3637 25.865 34.7784 25.2447C35.1931 24.6245 35.3445 23.8649 35.1992 23.1331C35.0539 22.4012 34.6238 21.7571 34.0036 21.3424ZM29.3151 19.0024C29.929 18.5768 30.6214 18.2777 31.3521 18.1226C32.0828 17.9675 32.837 17.9595 33.5708 18.099C34.3046 18.2385 35.0033 18.5228 35.6261 18.9353C36.2488 19.3477 36.7832 19.8801 37.198 20.5012C37.6128 21.1224 37.8998 21.82 38.0421 22.5533C38.1844 23.2866 38.1792 24.0408 38.0269 24.7721C37.8746 25.5034 37.5781 26.1969 37.1549 26.8124C36.7316 27.4279 36.19 27.9529 35.5617 28.3568C34.3211 29.1422 32.8225 29.4114 31.3861 29.1069C29.9497 28.8024 28.6894 27.9482 27.8742 26.727C27.059 25.5057 26.7537 24.0141 27.0235 22.5708C27.2933 21.1274 28.1167 19.8468 29.3179 19.0024H29.3151ZM28.9804 30.6827H35.8992C37.2195 30.6827 38.4857 31.2072 39.4192 32.1408C40.3528 33.0743 40.8773 34.3405 40.8773 35.6608V37.7421H38.0648V35.6608C38.0686 35.3754 38.0152 35.0921 37.9077 34.8276C37.8002 34.5632 37.6408 34.3229 37.4389 34.1211C37.2371 33.9192 36.9968 33.7598 36.7324 33.6523C36.4679 33.5448 36.1846 33.4914 35.8992 33.4952H28.9804C28.695 33.4914 28.4117 33.5448 28.1472 33.6523C27.8828 33.7598 27.6425 33.9192 27.4407 34.1211C27.2388 34.3229 27.0794 34.5632 26.972 34.8276C26.8645 35.0921 26.811 35.3754 26.8148 35.6608V43.3671H29.6273V52.6764C29.6273 52.8256 29.6866 52.9687 29.7921 53.0742C29.8975 53.1797 30.0406 53.2389 30.1898 53.2389H32.4398V56.1077H30.1898C29.2947 56.1077 28.4363 55.7521 27.8033 55.1192C27.1704 54.4862 26.8148 53.6278 26.8148 52.7327V46.1796C26.0339 46.1359 25.3014 45.7871 24.7753 45.2084C24.2492 44.6297 23.9716 43.8673 24.0023 43.0858V35.6608C24.0023 34.3405 24.5268 33.0743 25.4604 32.1408C26.3939 31.2072 27.6601 30.6827 28.9804 30.6827Z'
                                fill='#4FC8E9'
                              />
                            </svg>
                            Add New Client
                          </Button>
                        </label>
                      </div>
                    </div>
                    
                    {console.log('🚀OUTPUT --> booking?.fromDate:', booking?.fromDate)}
                    {booking && (
                      <div className='info_row info_row_date '>
                        <div className='field'>
                          <div>From</div>
                          <div className='date_time'>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                // shouldDisableDate={(23, 24, 25) => true}
                                // disablePast
                                format={'yyyy-MM-dd'}
                                label='Date'
                                // readOnly
                                value={new Date(booking?.fromDate + 'T' + booking?.fromTime)}
                                // value={format(booking?.fromDate, 'yyyy-MM-dd')}
                                // format(, 'yyyy-MM-dd') + 'T' + booking?.fromTime
                                onChange={(newValue) => {
                                  dispatch(
                                    setBooking({
                                      ...booking,
                                      fromDate: isValid(newValue)
                                        ? dayjs(newValue)?.format('YYYY-MM-DD')
                                        : newValue,
                                    })
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className='time_date_picker'
                                    size='small'
                                    // onKeyDown={(e) => e.preventDefault()}
                                    required
                                    {...params}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <TimeDropdown
                                setSelectedTime={(value) =>
                                  dispatch(
                                    setBooking({ ...booking, fromTime: value })
                                  )
                                }
                                selectedTime={booking?.fromTime?.slice(0, 5)}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className='field'>
                          <div>Until</div>
                          <div className='date_time'>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                // disablePast
                                label='Date'
                                format={'yyyy-MM-dd'}
                                value={new Date(booking?.untilDate + 'T' + booking?.untilTime)}
                                // value={format(booking?.untilDate, 'yyyy-MM-dd')}
                                // format(, 'yyyy-MM-dd') + 'T' + booking?.untilTime
                                onChange={(newValue) => {
                                  dispatch(
                                    setBooking({
                                      ...booking,
                                      untilDate: isValid(newValue)
                                        ? dayjs(newValue)?.format('YYYY-MM-DD')
                                        : newValue,
                                    })
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    size='small'
                                    onKeyDown={(e) => e.preventDefault()}
                                    className='time_date_picker'
                                    {...params}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <TimeDropdown
                                setSelectedTime={(value) =>
                                  dispatch(
                                    setBooking({ ...booking, untilTime: value })
                                  )
                                }
                                selectedTime={booking?.untilTime?.slice(0, 5)}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </div>
                    )}
                    <CarDropdown
                      bookingId={booking.id}
                      setSelectedCar={(value) =>
                        dispatch(setBooking({ ...booking, car: value }))
                      }
                      setSelectedCarDetail={(value) =>
                        setCarDetail(value)
                      }
                      setCarsDDLoading={(loading)=> {
                        setLoading(loading);
                      }}
                      selectedCar={selectedCar}
                      // fromDate={format_date_time(fromDate, fromTime)}
                      // untilDate={format_date_time(untilDate, untilTime)}
                      fromDate={fromDate + 'T' + fromTime.substring(0, 5)}
                      untilDate={untilDate + 'T' + untilTime.substring(0, 5)}
                      bookingPeriod={days}
                      deliveryCharge={deliveryCharge}
                      coupon={(coupons || []).find(
                        (coupon) => coupon.code == selectedCoupon
                      )}
                      isYoung={isYoung}
                    />

                    <CouponDropdown
                      couponData={coupons || []}
                      setSelectedCoupon={(value) =>
                        dispatch(setBooking({ ...booking, coupon_code: value }))
                      }
                      selectedCoupon={selectedCoupon}
                    />
                    <div className='info_row'>
                      <div className='field'>
                        Pickup Location
                        <FormControl
                          className='edit_dropdown'
                          sx={{ m: 1, minWidth: 120 }}
                        >
                          {/* <InputLabel id='airport_name'>
                          Select Airport Name
                        </InputLabel>  */}
                          <Select
                            className='airport_name'
                            labelId='airport_name'
                            id='demo-simple-select'
                            value={
                              // !booking?.pickup_location ||
                              // booking?.pickup_location === 'string'
                              //   ? booking?.destination_location
                              //   : booking?.pickup_location
                              booking?.pickup_location
                            }
                            label='Enter Airport Name'
                          >
                            {(airports || []).map((airport) => (
                              <MenuItem
                                key={airport.id}
                                className='airport_name_menu_item'
                                value={airport.airport}
                                onClick={() => {
                                  dispatch(
                                    setBooking({
                                      ...booking,
                                      pickupLocation: airport,
                                      pickup_location: airport.airport
                                    })
                                  );
                                }}
                              >
                                <svg
                                  style={{ marginRight: '10px' }}
                                  width='14'
                                  viewBox='0 0 14 17'
                                  fill='none'
                                >
                                  <path
                                    d='M7 16.796L2.227 12.023C1.28301 11.079 0.64014 9.87626 0.379696 8.56689C0.119253 7.25752 0.25293 5.90032 0.763824 4.66693C1.27472 3.43353 2.13988 2.37933 3.24991 1.63764C4.35994 0.895939 5.66498 0.500061 7 0.500061C8.33502 0.500061 9.64006 0.895939 10.7501 1.63764C11.8601 2.37933 12.7253 3.43353 13.2362 4.66693C13.7471 5.90032 13.8808 7.25752 13.6203 8.56689C13.3599 9.87626 12.717 11.079 11.773 12.023L7 16.796ZM10.7125 10.9625C11.4467 10.2283 11.9466 9.29279 12.1492 8.27441C12.3517 7.25602 12.2477 6.20045 11.8503 5.24117C11.4529 4.28189 10.78 3.46198 9.91669 2.88513C9.05334 2.30827 8.03833 2.00038 7 2.00038C5.96167 2.00038 4.94666 2.30827 4.08331 2.88513C3.21997 3.46198 2.54706 4.28189 2.14969 5.24117C1.75231 6.20045 1.64831 7.25602 1.85084 8.27441C2.05337 9.29279 2.55333 10.2283 3.2875 10.9625L7 14.675L10.7125 10.9625ZM7 8.75C6.60218 8.75 6.22065 8.59197 5.93934 8.31066C5.65804 8.02936 5.5 7.64783 5.5 7.25C5.5 6.85218 5.65804 6.47065 5.93934 6.18934C6.22065 5.90804 6.60218 5.75 7 5.75C7.39783 5.75 7.77936 5.90804 8.06066 6.18934C8.34197 6.47065 8.5 6.85218 8.5 7.25C8.5 7.64783 8.34197 8.02936 8.06066 8.31066C7.77936 8.59197 7.39783 8.75 7 8.75Z'
                                    fill='white'
                                  />
                                </svg>
                                {airport.airport} (+${airport.delivery_charge})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className='field'>
                        Dropoff Location
                        <FormControl
                          className='edit_dropdown'
                          sx={{ m: 1, minWidth: 120 }}
                        >
                          <Select
                            className='airport_name'
                            labelId='airport_name'
                            id='demo-simple-select'
                            value={booking?.destination_location}
                            label='Enter Airport Name'
                          >
                            {(airports || []).map((airport) => (
                              <MenuItem
                                key={airport.id}
                                className='airport_name_menu_item'
                                value={airport.airport}
                                onClick={() => {
                                  dispatch(
                                    setBooking({
                                      ...booking,
                                      dropoffLocation: airport,
                                      destination_location:airport.airport
                                    })
                                  );
                                }}
                              >
                                <svg
                                  style={{ marginRight: '10px' }}
                                  width='14'
                                  viewBox='0 0 14 17'
                                  fill='none'
                                >
                                  <path
                                    d='M7 16.796L2.227 12.023C1.28301 11.079 0.64014 9.87626 0.379696 8.56689C0.119253 7.25752 0.25293 5.90032 0.763824 4.66693C1.27472 3.43353 2.13988 2.37933 3.24991 1.63764C4.35994 0.895939 5.66498 0.500061 7 0.500061C8.33502 0.500061 9.64006 0.895939 10.7501 1.63764C11.8601 2.37933 12.7253 3.43353 13.2362 4.66693C13.7471 5.90032 13.8808 7.25752 13.6203 8.56689C13.3599 9.87626 12.717 11.079 11.773 12.023L7 16.796ZM10.7125 10.9625C11.4467 10.2283 11.9466 9.29279 12.1492 8.27441C12.3517 7.25602 12.2477 6.20045 11.8503 5.24117C11.4529 4.28189 10.78 3.46198 9.91669 2.88513C9.05334 2.30827 8.03833 2.00038 7 2.00038C5.96167 2.00038 4.94666 2.30827 4.08331 2.88513C3.21997 3.46198 2.54706 4.28189 2.14969 5.24117C1.75231 6.20045 1.64831 7.25602 1.85084 8.27441C2.05337 9.29279 2.55333 10.2283 3.2875 10.9625L7 14.675L10.7125 10.9625ZM7 8.75C6.60218 8.75 6.22065 8.59197 5.93934 8.31066C5.65804 8.02936 5.5 7.64783 5.5 7.25C5.5 6.85218 5.65804 6.47065 5.93934 6.18934C6.22065 5.90804 6.60218 5.75 7 5.75C7.39783 5.75 7.77936 5.90804 8.06066 6.18934C8.34197 6.47065 8.5 6.85218 8.5 7.25C8.5 7.64783 8.34197 8.02936 8.06066 8.31066C7.77936 8.59197 7.39783 8.75 7 8.75Z'
                                    fill='white'
                                  />
                                </svg>
                                {airport.airport} (+${airport.delivery_charge})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className='info_row'>
                      <div className='field'>
                        Airline
                        <FormControl
                          className='edit_dropdown'
                          sx={{ m: 1, minWidth: 120 }}
                        >
                          {/* <InputLabel id='airport_name'>
                            Select Airport Name
                          </InputLabel> */}
                          <Select
                            className='airport_name'
                            labelId='airport_name'
                            id='demo-simple-select'
                            value={booking?.airline_name}
                            label='Enter Airport Name'
                            onChange={(e) =>
                              dispatch(
                                setBooking({
                                  ...booking,
                                  airline_name: e.target.value,
                                })
                              )
                            }
                          >
                            {(airlines || []).map((airline) => (
                              <MenuItem
                                key={airline.id}
                                className='airport_name_menu_item'
                                value={airline.name}
                              >
                                <svg
                                  style={{ marginRight: '10px' }}
                                  width='14'
                                  viewBox='0 0 14 17'
                                  fill='none'
                                >
                                  <path
                                    d='M7 16.796L2.227 12.023C1.28301 11.079 0.64014 9.87626 0.379696 8.56689C0.119253 7.25752 0.25293 5.90032 0.763824 4.66693C1.27472 3.43353 2.13988 2.37933 3.24991 1.63764C4.35994 0.895939 5.66498 0.500061 7 0.500061C8.33502 0.500061 9.64006 0.895939 10.7501 1.63764C11.8601 2.37933 12.7253 3.43353 13.2362 4.66693C13.7471 5.90032 13.8808 7.25752 13.6203 8.56689C13.3599 9.87626 12.717 11.079 11.773 12.023L7 16.796ZM10.7125 10.9625C11.4467 10.2283 11.9466 9.29279 12.1492 8.27441C12.3517 7.25602 12.2477 6.20045 11.8503 5.24117C11.4529 4.28189 10.78 3.46198 9.91669 2.88513C9.05334 2.30827 8.03833 2.00038 7 2.00038C5.96167 2.00038 4.94666 2.30827 4.08331 2.88513C3.21997 3.46198 2.54706 4.28189 2.14969 5.24117C1.75231 6.20045 1.64831 7.25602 1.85084 8.27441C2.05337 9.29279 2.55333 10.2283 3.2875 10.9625L7 14.675L10.7125 10.9625ZM7 8.75C6.60218 8.75 6.22065 8.59197 5.93934 8.31066C5.65804 8.02936 5.5 7.64783 5.5 7.25C5.5 6.85218 5.65804 6.47065 5.93934 6.18934C6.22065 5.90804 6.60218 5.75 7 5.75C7.39783 5.75 7.77936 5.90804 8.06066 6.18934C8.34197 6.47065 8.5 6.85218 8.5 7.25C8.5 7.64783 8.34197 8.02936 8.06066 8.31066C7.77936 8.59197 7.39783 8.75 7 8.75Z'
                                    fill='white'
                                  />
                                </svg>
                                {airline.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className='field'>
                        Flight No
                        <FormControl
                          className='edit_dropdown'
                          sx={{ m: 1, minWidth: 120 }}
                        >
                          <TextField
                            size='small'
                            placeholder='Flight No'
                            value={booking?.flight_number}
                            onChange={(e) =>
                              dispatch(
                                setBooking({
                                  ...booking,
                                  flight_number: e.target.value,
                                })
                              )
                            }
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className='info_row'>
                      <FormControlLabel
                        className='booking feature_checkbox_wrapper'
                        control={
                          <Checkbox
                            className='feature_checkbox'
                            checked={booking.send_confirmation}
                            onChange={(e) =>
                              dispatch(
                                setBooking({
                                  ...booking,
                                  send_confirmation: e.target.checked,
                                })
                              )
                            }
                          />
                        }
                        label={
                          <div className='feature_checkbox_label_wrapper'>
                            <div className='feature_checkbox_label'>
                              {/* {getPage(packagePage.page)?.mutate == true? "View": 'View/Mutate'} */}
                              Send Confirmation
                            </div>
                          </div>
                        }
                      />
                    </div>
                  </div>
                  <div className='confirmation_btn'>
                    <button type='submit'> Save </button>
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
      {(loading || !selectedCar) && (
        <Box className='mainLoader'>
          <CircularProgress color='primary' />
        </Box>
      )}
    </div>
  );
}
